import { makeStyles } from '@material-ui/core/styles';
import rciImage from '../../img/stock-photo.jpg';
import ahrqImage from '../../img/AHRQ-image.jpg';
import ahrqImage2 from '../../img/AHRQ-2-image.jpg';
import ashaImage from '../../img/ASHA-image.jpg';

const homeClasses = makeStyles((theme) => ({
  missionAlign: {
    textAlign: "center",
    [theme.breakpoints.up('md')]: {
      textAlign: "left",
    },
  },



  statStyle: {
    padding: '20px 10px',
  },
  carouselSpacing: {
    paddingLeft: 24,
  },
  dividerStat: {
    height: 4,
    width:'35%',
    backgroundColor: '#D8F6EF',
    marginBottom: 12,
    marginTop:6,
  },
  rciImg: {
    backgroundImage:`url(${rciImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:500,
    borderRadius: 30,
    marginRight: 30,
    marginLeft: '-30px',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginLeft: 0,
      minHeight: 300,
    },
  },
  ashaImg: {
    backgroundImage:`url(${ashaImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:500,
    borderRadius: 30,
    marginRight: 30,
    marginLeft: '-30px',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginLeft: 0,
      minHeight: 300,
    },
  },
  ahrqImg: {
    backgroundImage:`url(${ahrqImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:500,
    borderRadius: 30,
    marginRight: 30,
    marginLeft: '-30px',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginLeft: 0,
      minHeight: 300,
    },
  },
  ahrqImg2: {
    backgroundImage:`url(${ahrqImage2})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:500,
    borderRadius: 30,
    marginRight: 30,
    marginLeft: '-30px',
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginLeft: 0,
      minHeight: 300,
    },
  },
  }));
  export default homeClasses
